import { ResourceTypes } from './tablelist.enum';
import { ITablelistActionConfig } from './tablelist-action.config.interface';

export interface ITablelistStateActionConfigTemplate {
  item?: ITablelistActionConfig;
  resourceType: ResourceTypes;
  reference?: string;
  configTemplateType: string;
  transactionId?: string;
}
